import React, { useState, useEffect } from "react";
import { Button, Text } from "components";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function CancelIRNInvoice() {
  const [visible, setvisible] = useState(true);
  const { id } = useParams();
  const location = useLocation();
  let navigate = useNavigate();
  const is_delivery_challan = location.state?.is_delivery_challan;

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  useEffect(() => {
    GetTaxInvoiceIRNEwayNo();
  }, []);

  const GetTaxInvoiceIRNEwayNo_obj = { id: id };
  const GetTaxInvoiceIRNEwayNo = () => {
    axios
      .post(
        "/api/purple-fusion/taxinvoice/get/e-invoice",
        GetTaxInvoiceIRNEwayNo_obj,
        headers
      )
      .then((response) => {
        console.log(response.data);
        formik.setFieldValue("Irn", response.data[0].irn);
        // formik.setFieldValue("ewbNo", response.data[0].ewbno);
        // setInvoicedetail(response.data[0]);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const validationSchema = Yup.object().shape({
    Irn: Yup.string().required(" IRN is Required"),
    // ewbNo: Yup.string().required("Eway bill number is Required"),
    CnlRem: Yup.string().required("Please select the reason"),
  });

  const formik = useFormik({
    initialValues: {
      Irn: "",
      //   ewbNo: "",
      CnlRsn: "",
      CnlRem: "",
      id: id,
      is_delivery_challan: is_delivery_challan,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });
  const options = [
    { value: "1", label: "Duplicate" },
    { value: "2", label: "Order Cancelled" },
    { value: "3", label: "Data Entry Mistake" },
    { value: "4", label: "Others" },
  ];

  const handleFormSubmit = (values) => {
    console.log(values);
    const errorMessage = `<a target="_blank" href="https://docs.ewaybillgst.gov.in/apidocs/api-error-codes-list.html"  style="color: #00f; text-decoration: underline;">Error List</a>`;
    axios
      .post("/api/purple-fusion/einvoice/cancelinvoice/byirn", values, headers)
      .then((response) => {
        console.log(response.data);
        const successmessage = response.data.message;
        let message = response.data.message;
        message = message.replace(/[\[\]{}\/\\"']/g, "");
        message = message.replace(/[\,\;]/g, "\n");
        console.log(message);
        response.data.status
          ? toast.success(successmessage, {
              autoClose: 2000,
              onClose: () => {
                //   setvisible(false);
                navigate(`/taxinvoice/cancel/list`);
              },
            })
          : toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
              autoClose: 2000,
            });
      })
      .catch((error) => {
        console.log(error);
        //   setvisible(false);
        //   navigate("*");
      });
  };

  const customStyles = {
    content: {
      width: "70%",
      height: "45%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  return (
    <>
      <Modal isOpen={visible} style={customStyles}>
        <form onSubmit={formik.handleSubmit}>
          <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
            <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
              <div className="flex flex-1 flex-col gap-[12px] justify-start md:px-5 w-full">
                <div className=" flex flex-row w-[100%]">
                  <div className="flex flex-row sm:gap-15 items-center justify-start w-full ">
                    <Text
                      className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px] "
                      size="txtInterMedium24"
                    >
                      Cancel Invoice
                    </Text>
                  </div>
                  <div className="flex flex-row items-center justify-start">
                    <Button
                      className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                      shape="round"
                      color="blue_A700"
                      size="base"
                      variant="fill"
                      type="submit"
                      // onClick={(e) => onHandleSubmit(e)}
                    >
                      Save
                    </Button>
                    <button
                      className="cursor-pointer sticky font-small mb-2 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                      shape="round"
                      color="white"
                      size="base"
                      variant="fill"
                      onClick={() => {
                        setvisible(false);
                        navigate(`/taxinvoice/cancel/list`);
                      }}
                    >
                      ╳
                    </button>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start md:ml-[0] ml-[25px] w-[87%] md:w-full  ">
                  <ToastContainer />
                  <div className="flex flex-col items-center justify-start w-full">
                    <div className="md:gap-5 gap-x-[75px] gap-y-4 grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black900"
                        >
                          <span className="text-black-700 font-inter font-small text-sm">
                            Tax Invoice IRN
                          </span>
                          <span className="text-red-A700 font-inter font-small text-sm">
                            *
                          </span>
                        </Text>
                        <input
                          name="irn"
                          type="text"
                          placeholder=" Enter IRN"
                          readOnly
                          // value={operation.name}
                          // onChange={handleInputChange}
                          value={formik.values.Irn}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                        ></input>
                        {formik.touched.Irn && formik.errors.Irn ? (
                          <div className="text-red-500 text-sm">
                            {formik.errors.Irn}
                          </div>
                        ) : null}
                      </div>
                      {/* 
                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black900"
                        >
                          <span className="text-black-700 font-inter font-small text-sm">
                            Reason
                          </span>
                          <span className="text-red-A700 font-inter font-small text-sm">
                            *
                          </span>
                        </Text>
                        <input
                          name="CnlRem"
                          type="text"
                          placeholder=" Enter Reason for cancel"
                          value={formik.values.CnlRem}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[5px] w-full"
                        ></input>
                        {formik.touched.CnlRem && formik.errors.CnlRem ? (
                          <div className="text-red-500 text-sm">
                            {formik.errors.CnlRem}
                          </div>
                        ) : null}
                      </div> */}
                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                        <label className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto">
                          <span className="text-black-700 font-inter font-small">
                            Select Reason
                          </span>
                          <span className="text-red-A700 font-inter font-small">
                            *
                          </span>
                        </label>

                        <Select
                          name="CnlRem"
                          options={options}
                          className="bg-white-A700 border border-gray-200_02 border-solid h-[40px] rounded-[10px] w-full"
                          onChange={(selectedOption) => {
                            formik.setFieldValue(
                              "CnlRsn",
                              selectedOption.value
                            );
                            formik.setFieldValue(
                              "CnlRem",
                              selectedOption.label
                            );
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Select Reason for cancel"
                          value={options.find(
                            (option) => option.value === formik.values.CnlRem
                          )}
                        />

                        {formik.touched.CnlRem && formik.errors.CnlRem ? (
                          <div className="text-red-500">
                            {formik.errors.CnlRem}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default CancelIRNInvoice;
